export enum AccountStatus {
    None = 0,
    Invited = 1,
    Unapproved = 2,
    Unverified = 3,
    Active = 4,
    Suspended = 5,
    Deleted = 6
}